// T053 — Bookmark toggled event definition.

import type { EventDefinition } from './navigation';

export type BookmarkToggledProperties = {
  marketPubkey: string;
  bookmarked: boolean;
};

export const BOOKMARK_TOGGLED: EventDefinition<BookmarkToggledProperties> = {
  name: 'bookmark_toggled',
};
